<script>
import { ref } from '@vue/composition-api'

export default {
  name: 'PreviewView',
  props: {
    rowItem: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    const visible = ref(true)

    return {
      visible,
    }
  },
}
</script>

<template>
  <vl-dialog
    :title="rowItem.title"
    :visible.sync="visible"
    width="800px"
    top="0"
    @closed="$emit('close')"
  >
    <div class="PreviewView ql-container">
      <div class="ql-editor" style="white-space: pre-wrap;" v-html="rowItem.content" />
    </div>
  </vl-dialog>
</template>

<style scoped lang="scss">
::v-deep .vl-dialog__title {
  text-align: center;
  flex: auto;
}

.PreviewView {
  //min-height: 500px;
  max-height: 500px;
  min-height: 280px;
  overflow: auto;
  white-space: pre-wrap;
}

.ql-editor {
  width: 735px;
  ::v-deep img {
    width: auto;      /* 当图片较小的时候保持原始大小 */
    max-width: 100%;  /* 当图片较大时限制最大宽度为容器宽度 */
    height: auto;
    object-fit: cover;
  }
}

::v-deep .vl-dialog__body {
  padding: 20px 0;
}
</style>
